export class GoogleCaptcha {
    constructor(options = {}) {
        this.parent = options.parent;
        if (!this.parent?.el) {
            return;
        }
        this.siteKey = options.siteKey;

        if (this.parent) {
            this.parent.subscribe('shown', this.onFormShown.bind(this));
        }
    }

    initScipt() {
        const baseSrc = 'https://www.google.com/recaptcha/api.js?render=';
        const script = document.createElement('script');
        script.src = baseSrc + this.siteKey;
        script.dataset.isRecaptcha = true;

        const otherScript = document.querySelector('script');
        if (otherScript) {
            otherScript.insertAdjacentElement('afterend', script);
        }
    }

    update(updateData) {

    }

    async prepareFormBeforeSend() {
        await new Promise((resolve, reject) => {
            if (!grecaptcha) {
                reject('grecaptcha not found');
                throw new Error('grecaptcha not found');
            }

            grecaptcha.ready(() => {
                grecaptcha.execute(this.siteKey, {action: 'submit'})
                    .then((token) => {
                        if (!this.parent.form['recaptcha-token']) {
                            reject('recaptcha token input not found');
                        }
                        this.parent.form['recaptcha-token'].value = token;
                        resolve();
                    });
            });
        });
    }

    onFormShown(e) {
        this.initScipt();
    }
}